export const introScreensTimeout = 2000;
